import {
  Component,
  OnInit,
  NgZone,
  Output,
  EventEmitter,
  TemplateRef,
  Input,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Injectable } from '@angular/core';
import { _ } from 'underscore';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { MapsAPILoader } from '@agm/core';
import { ResidentialService } from '../../residential.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { holidays } from '../../../../../assets/holidays';
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { AdjustTimeService } from 'src/app/questionarie-signup/adjust-time.service';
import { threadId } from 'worker_threads';
@Component({
  selector: 'app-service-type',
  templateUrl: './service-type.component.html',
  styleUrls: ['./service-type.component.css', '../signup-order.component.css'],
})

@Injectable({
  providedIn: 'root',
})
export class ServiceTypeComponent implements OnInit {
  @Output() sendDetails: EventEmitter<any> = new EventEmitter();
  @Input() esiid_value: any;
  orderDetails = false;
  showService = false;
  sp_src;
  ns_src;
  hgService;
  isChecked = false;
  showdate_trigger = true;
  elem1;
  elem2;
  deviceWidth;
  hgSwitch;
  isSwitchChecked = false;
  swtprd = false;
  hgNewService;
  questions;
  selectedProduct;
  userResponses = [];
  averagePrice;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  ShowConfirm;
  serviceType;
  switchTypeValue;
  date;
  public model: any;
  public switchModel: any;
  serviceDisable = true;
  selectedSwitchValue;
  selectdSwitchDate;
  IsOffSwitch = false;
  showDate = false;
  alertEnable = false;
  btnEnable = true;
  ngClass = true;
  disableDays: Array<IMyDate> = [];
  public myDatePickerOptions: IMyDpOptions;
  disableAfter: IMyDate;
  // hgHolidays;
  providerContactInfo = [];
  providerContact;
  // For mobile view
  showEnrollmentComp = false;
  modalRef: BsModalRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;

  tableElements = [
    {
      thead: 'Move In',
      rowElements: [
        '$3.00',
        '$1.00',
        '$16.00',
        '$1.00',
        '$0.70',
        '$49.80',
        '$1.50',
      ],
    },
    {
      thead: 'Priority Move In',
      rowElements: [
        '$9.00',
        '$5.00',
        '$36.00',
        '$2.00',
        '$1.70',
        '$79.27',
        '$26.50',
      ],
    },
    {
      thead: 'Self-Select Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$3.00',
        '$0.15',
        '$7.00',
        '$0.40',
      ],
    },
    {
      thead: 'Standard Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
      ],
    },
  ];
  thead;
  rowElements = [];
  tableIndex;
  userResponseUpdated = {
    userResponses: [],
  };
  private loadActualUtilityName = {
    AEPC: 'AEP Texas Central',
    AEPN: 'AEP Texas North',
    TNMP: 'Texas New Mexico Power',
    CNP: 'Centerpoint',
    ONC: 'Oncor',
    SHAR: 'Sharyland Utility',
    NUEC: 'NEC',
    LPL:'Lubbock Power and Light'
  };
  tduRates: any;
  hgHolidays = holidays.hgHolidays;
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  placeholderText = 'MM/DD/YYYY';
  getOperating: string;
  navigatorBrowser: string;
  constructor(
    private residentialService: ResidentialService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private recommendationService: RecommendationService,
    private modalService: BsModalService,
    private router: Router,
    private timeZoneService: AdjustTimeService
  ) {
    try{
    this.hgService = {
      ns: false,
      sp: false,
    };
    this.hgSwitch = {
      switchValue1: false,
      switchValue2: false,
    };
    this.hgNewService = {
      newServiceValue1: false,
      newServiceValue2: false,
    };
    this.questions = this.residentialService.getQues();
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }

    if (this.residentialService.userResponse != null && !_.isEmpty(this.residentialService.userResponse.userResponses)) {
     
      var check = JSON.parse(
        sessionStorage.getItem('userResponse')
      )
      if(check != null)
      {
        this.userResponses = JSON.parse(
          sessionStorage.getItem('userResponse')
        ).userResponses;
  
      }

    } else {
      var check = JSON.parse(
        sessionStorage.getItem('userResponse')
      )
      if(check != null)
      {
        this.userResponses = JSON.parse(
          sessionStorage.getItem('userResponse')
        ).userResponses;
  
      }
    }

    this.deviceWidth = window.innerWidth;
    this.averagePrice = (
      Number(this.selectedProduct.new_tier.ave_price_per_KWH) * 100
    ).toFixed(1);
    this.t1_avg_charge = (
      Number(this.selectedProduct.tier[0].avg_charge) * 100
    ).toFixed(1);
    this.t2_avg_charge = (
      Number(this.selectedProduct.tier[1].avg_charge) * 100
    ).toFixed(1);
    this.t3_avg_charge = (
      Number(this.selectedProduct.tier[2].avg_charge) * 100
    ).toFixed(1);
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.thead = this.tableElements[0].thead;
    this.rowElements = this.tableElements[0].rowElements;
    this.tableIndex = 0;
  }catch{
      
  }
  }
  minDate = this.timeZoneService.updateTime('America/Chicago');
  maxDate = new Date(new Date().setDate(new Date().getDate() + 60));

  ngOnInit() {
    try{
    this.getOperating = this.getOS();
    this.navigatorBrowser = this.residentialService.myBrowser();
    this.tduRates = JSON.parse(sessionStorage.getItem('tduRates'));
    this.getElementsForFieldObjects();
    this.userResponseUpdated = JSON.parse(
      sessionStorage.getItem('userResponse')
    );

    const currentDate = new Date();
    const targetDate = new Date('2024-04-02');
    if (currentDate < targetDate && this.selectedProduct.utility_name == "LPL")
    {
      this.IsOffSwitch = true;
    }

    if (this.userResponses.length > 0 && !this.IsOffSwitch) {
      const obj = _.findWhere(this.userResponses, { res_question_id: '002' });
      if (!_.isEmpty(obj)) {
        this.serviceType = obj.fieldValue;
        this.serviceType === 'New Service'
          ? this.assignValuesForNewServiceType()
          : this.assignValuesForSwitchProviders();
        this.selectedSwitchValue = this.switchTypeValue;
        this.selectdSwitchDate = sessionStorage.getItem('selectdSwitchDate');
        this.ShowConfirm = true;
      }
    }
    else
    {
      this.serviceType = 'New Service';
      
      //if (this.deviceWidth < 768) {

      this.hgNewService.newServiceValue2 = false;
      if (this.userResponses.length > 0)
      {
        
      }else
      {
        this.assignValuesForNewServiceType();
        this.ns_src = 'assets/images/ns_disable.png';
        this.showDate = false;
        this.btnEnable = false;
        this.ngClass = false;
      }
      this.hgService = {
        ns: false,
        sp: false,
      };
      if (this.deviceWidth > 768) 
      {
        //$("#NewService").parent().parent().addClass('active-select')
        //$("#NewService").prop("checked", true).trigger("click")
      }
     
      //}
    }


    if (this.IsOffSwitch)
    {
      this.IsOffSwitch = true;
      this.ShowConfirm = true;
      //if(this.deviceWidth > 786)
      //{
        this.hgService = {
          ns: true,
          sp: false,
        };

        if (this.deviceWidth > 768) 
        {
          $("#NewService").parent().parent().addClass('active-select')
          $("#NewService").prop("checked", true).trigger("click")
        }else
        {
          $("#NewService_mob").parent().parent().addClass('active-select')
          $("#NewService_mob").prop("checked", true).trigger("click")
        }
       
      //}
      
    }
    this.REPStartDates()

  }catch{
      
  }
  }

  getElementsForFieldObjects() {
    this.elem1 = document.getElementById('NewService');
    this.elem2 = document.getElementById('SwitchingProviders');
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('NewService_mob');
      this.elem2 = document.getElementById('SwitchingProviders_mob');
    }
  }

  assignValuesForNewServiceType() {
    this.ns_src = 'assets/images/Newservice.png';
    this.sp_src = 'assets/images/switch-providers-gray.png';
    this.hgService = {
      ns: true,
      sp: false,
    };

    if(this.deviceWidth < 768 && this.userResponses.length == 0)
    {
      this.hgService = {
        ns: false,
        sp: false,
      };


    }

    this.swtprd = false;
    // this.elem1.parentElement.parentElement.classList.add('active-select');
    // this.elem2.parentElement.parentElement.classList.add('active-disabled');
    this.hgNewService = {
      newServiceValue1: false,
      newServiceValue2: true,
    };
    this.showDate = true;
    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    //TODO: Below logic was written to bypass the switchDate value for iOS mobile version and Safari Browser.
    // Will look into the logic or refactor the code once the high priority issues are completed.
    if (!_.isEmpty(switchDateObj)) {
      this.deviceWidth > 768 && this.navigatorBrowser === 'Chrome'
        ? this.setSwitchDateForNewServiceType(switchDateObj)
        : this.setSwitchDateForNewServiceTypeMobile(switchDateObj);
      // if (this.deviceWidth > 768 && this.navigatorBrowser === 'Chrome') {
      //   this.setSwitchDateForNewServiceType(switchDateObj);
      // } else {
      //   this.setSwitchDateForNewServiceTypeMobile(switchDateObj);
      // }
    }
    const someDate = new Date();
    const numberOfDaysToAdd = 2;
    someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
    if (new Date(this.date) < someDate) {
      this.switchTypeValue = 'Priority Move-In';
      this.hgNewService = {
        newServiceValue1: true,
        newServiceValue2: false,
      };
    }
  }
  setSwitchDateForNewServiceTypeMobile(switchDateObj: any) {
    if (switchDateObj.fieldValue) {
      this.date = switchDateObj.fieldValue;
      this.model = this.date;
      if (
        this.navigatorBrowser === 'Safari' &&
        sessionStorage.getItem('selectdSwitchDate')
      )
        this.model = this.setSwitchDateValueForSafari();
    }
    if (
      switchDateObj.startDateType &&
      switchDateObj.startDateType === 'Priority Move-In'
    ) {
      this.hgNewService = {
        newServiceValue1: true,
        newServiceValue2: false,
      };
      this.showDate = false;
      this.switchTypeValue = 'Priority Move-In';
    } else {
      this.hgNewService = {
        newServiceValue1: false,
        newServiceValue2: true,
      };
      this.switchTypeValue = 'Standard Move-In';
      this.model = this.setSwitchDateForMobile(this.model);
      sessionStorage.setItem('selectdSwitchDate', this.model);
    }
  }

  setSwitchDateValueForSafari() {
    if (sessionStorage.getItem('selectdSwitchDate')) {
      const dateObj = sessionStorage.getItem('selectdSwitchDate');
      //alert('safari balue' + dateObj);
      return dateObj;
    }
  }

  setSwitchDateForNewServiceType(switchDateObj) {
    // if (switchDateObj.fieldValue) {
    this.date = switchDateObj.fieldValue;
    this.model = this.date;
    if (typeof this.date === 'string') {
      this.date = new Date(this.date);
      this.model = new Date(this.date);
    }
    // }
    if (
      switchDateObj.startDateType &&
      switchDateObj.startDateType === 'Priority Move-In'
    ) {
      this.hgNewService = {
        newServiceValue1: true,
        newServiceValue2: false,
      };
      this.showDate = false;
      this.switchTypeValue = 'Priority Move-In';
      localStorage.setItem('SwitchDate', this.switchTypeValue);
    } else {
      this.hgNewService = {
        newServiceValue1: false,
        newServiceValue2: true,
      };
      this.switchTypeValue = 'Standard Move-In';
      if (typeof this.date === 'string') {
        this.date = new Date(this.date);
      }
      this.model = this.dateObjectCstFormatted(this.date);
      sessionStorage.setItem('selectdSwitchDate', this.date);
    }
  }

  setSwitchDateForMobile(itemValue) {
    let endDate;
    if (this.deviceWidth < 768 || this.navigatorBrowser === 'Safari') {
      const model = itemValue.split(' ');
      if (model.length > 2) {
        endDate = new Date(itemValue);
      } else {
        const modelDate = model[0];
        endDate = new Date(modelDate);
        endDate.setDate(new Date(endDate).getDate() + 1);
      }
      return endDate;
    }
  }

  assignValuesForSwitchProviders() {
    if (this.serviceType === 'Switching Providers') {
      this.ns_src = 'assets/images/ns_disable.png';
      this.sp_src = 'assets/images/switch-providers-pink.png';
      this.hgService = {
        ns: false,
        sp: true,
      };
      this.swtprd = true;
      try{
        this.elem2.parentElement.parentElement.classList.add('active-select');
        this.elem1.parentElement.parentElement.classList.add('active-disabled');
      }catch{

      }
    
      const switchType = _.findWhere(this.userResponses, {
        res_question_id: '004',
      });
      if (!_.isEmpty(switchType)) {
        this.switchTypeValue = switchType.fieldValue;
        if (this.switchTypeValue === 'Standard Switch') {
          this.hgSwitch = {
            switchValue1: true,
            switchValue2: false,
          };
          this.showDate = false;
        } else if (this.switchTypeValue === 'Self-Selected Switch') {
          this.hgSwitch = {
            switchValue1: false,
            switchValue2: true,
          };
          this.showDate = true;
          const switchDateObj = _.findWhere(this.userResponses, {
            res_question_id: '005',
          });
          //TODO: Below logic was written to bypass the switchDate value for iOS mobile version and Safari browser.
          // Will work on new logic or refactor the code once the priority issues are completed.
          if (!_.isEmpty(switchDateObj)) {
            if (this.deviceWidth > 768 && this.navigatorBrowser === 'Chrome') {
              this.date = switchDateObj.fieldValue;
              if (typeof this.date === 'string') {
                this.date = new Date(this.date);
              }
              this.switchModel = this.date;
              sessionStorage.setItem('selectdSwitchDate', this.switchModel);
            } else {
              this.date = switchDateObj.fieldValue;
              this.switchModel = this.date;

              if (
                this.navigatorBrowser === 'Safari' &&
                this.deviceWidth > 768 &&
                sessionStorage.getItem('selectdSwitchDate')
              ) {
                alert(sessionStorage.getItem('selectdSwitchDate'));
                this.switchModel = sessionStorage.getItem('selectdSwitchDate');
              } else {
                this.switchModel = this.setSwitchDateForMobile(
                  this.switchModel
                );
                sessionStorage.setItem('selectdSwitchDate', this.switchModel);
              }
            }
          }
        }
      }
    }
  }

  formatDateObject(dateObj) {
    const itemValue = new Date(dateObj);
    return `${
      itemValue.getMonth() + 1
    }/${itemValue.getDate()}/${itemValue.getFullYear()}`;
  }

  setBlackOutDates() {
    // this.hgHolidays = holidays.hgHolidays;
    holidays.hgHolidays.map((row: any) => {
      this.disableDays.push({
        year: row.year,
        month: row.month,
        day: row.day,
      });
    });
    const after60Days = new Date().setDate(new Date().getDate() + 60);
    this.disableAfter = {
      year: new Date(after60Days).getFullYear(),
      month: new Date(after60Days).getMonth() + 1,
      day: new Date(after60Days).getDate(),
    };
    const realday = this.getRealDay();
    let newDate = moment(new Date())
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
        .toString(),
      m = moment.utc(newDate);
    m.tz('America/Chicago');
    const cstTime = m.format('HHmm'),
      cstDate = m.format('MM-DD-YYYY'),
      lastday = new Date(
        new Date(cstDate).getFullYear(),
        new Date(cstDate).getMonth() + 1,
        0
      ).getDate(),
      month =
        cstTime < '1500' && new Date(cstDate).getDate() === lastday
          ? new Date(cstDate).getMonth() + 1
          : new Date().getMonth() + 1,
      day = cstTime < '1500' ? new Date(cstDate).getDate() : realday - 1;
    let datesDisabledUntil = {
      year: new Date().getFullYear(),
      month: month,
      day: day,
    };
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek: 'su',
      disableSince: this.disableAfter,
      disableDays: this.disableDays,
      disableWeekends: true,
      disableUntil: datesDisabledUntil,
      editableDateField: false,
      showClearDateBtn: false,
      selectorHeight: '100%',
      selectorWidth: '100%',
      openSelectorOnInputClick: true,
    };
  }

  getMonthForRealDay(realday) {
    var lastday = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      0
    ).getDate();
    return realday - 1 === 0
      ? new Date().getMonth()
      : new Date().getMonth() + 1;
  }
  getRealDay() {
    if (new Date().getDay() === 5) {
      return new Date().getDate() + 3;
    } else {
      var dd = _.filter(this.disableDays, {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
      });
      return new Date().getDate();
    }
  }

  getServiceType(event) {
    if(this.IsOffSwitch)
    {
      $("#SwitchingProviders").prop('checked',false)
      $("#NewService").prop('checked',true)

      $("#SwitchingProviders_mob").prop('checked',false)
      $("#NewService_mob").prop('checked',true)

      this.hgService = {
        ns: true,
        sp: false,
      };
      
     
      sessionStorage.setItem('serviceType', 'New Service');


      this.setUpdateServiceTypes('New Service');
      let ev = event.target.value;
      this.residentialService.updateResultList(ev);
      return;
    }

    if(event.currentTarget.checked == false)
    {
      $("#" + event.target.id).prop('checked',true)
      return;
    }

    let ev = event.target.value;
    this.ShowConfirm = true;
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('NewService_mob');
      this.elem2 = document.getElementById('SwitchingProviders_mob');
      

   
        setTimeout(() => {
          $(".lnhgt20")[0].scrollIntoView();
        }, 1000);

       
        this.btnEnable = false;
        this.ngClass = false;
      

    } else {
      this.elem1 = document.getElementById('NewService');
      this.elem2 = document.getElementById('SwitchingProviders');
    }

    this.residentialService.updateResultList(ev);

    if (ev === 'Switching Providers') {
      this.ns_src = 'assets/images/ns_disable.png';
      this.sp_src = 'assets/images/switch-providers-pink.png';
      this.serviceType = 'Switching Providers';
      this.elem2.parentElement.parentElement.classList.add('active-select');
      this.elem1.parentElement.parentElement.classList.remove('active-select');
      this.swtprd = true;
      this.showDate = true;

    

      this.hgService = {
        ns: false,
        sp: true,
      };
      this.hgSwitch = {
        switchValue1: false,
        switchValue2: false,
      };
      this.showDate = false;
      //this.selectedSwitchValue = 'Standard Switch';
      //sessionStorage.setItem('selectedSwitchValue', 'Standard Switch');

      sessionStorage.setItem('selectdSwitchDate', '');
      sessionStorage.setItem('serviceType', 'Switching Providers');
      this.setUpdateServiceTypes('Switching Providers');
      if (this.deviceWidth > 768) 
      {
        //this.alertEnable = false;
        this.btnEnable = false;
        this.ngClass = false;
        //this.hgSwitch.switchValue1 = true;
      }

      $("#NewService").prop('checked',false)
      $("#SwitchingProviders").prop('checked',true)
      $("#NewService_mob").prop('checked',false)
      $("#SwitchingProviders_mob").prop('checked',true)
      
      
    } else {
      // this.hgNewService = {
      //   newServiceValue1: false,
      //   newServiceValue2: false,
      // };

      this.ns_src = 'assets/images/Newservice.png';
      this.sp_src = 'assets/images/switch-providers-gray.png';

      this.showDate = false;
      this.serviceType = 'New Service';
      this.swtprd = false;
      this.hgNewService = {
        newServiceValue1: false,
        newServiceValue2: false,
        };

        if (this.deviceWidth > 768) {
            //this.hgNewService.newServiceValue2 = true;
            //this.showDate = true;
            this.btnEnable = false;
            this.ngClass = false;
        }
      
      //this.selectedSwitchValue = 'Standard Move-In';
      this.selectdSwitchDate = '';
      sessionStorage.setItem('selectdSwitchDate', '');
      this.model = '';
      sessionStorage.setItem('serviceType', 'New Service');
      try{
        this.elem2.parentElement.parentElement.classList.remove('active-select');
      }catch{
        
      }
      this.elem1.parentElement.parentElement.classList.add('active-select');
      $("#SwitchingProviders").prop('checked',false)
      $("#NewService").prop('checked',true)
      $("#SwitchingProviders_mob").prop('checked',false)
      $("#NewService_mob").prop('checked',true)
      this.hgService = {
        ns: true,
        sp: false,
      };
      this.setUpdateServiceTypes('New Service');
    }
    
  }

  setUpdateServiceTypes(serviceType) {
    const questionnaireStatusObj = {
      questionStatus: 'Completed',
      questionStep: '0026',
      type: serviceType,
    };
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionnaireStatusObj)
    );
    const data = {
      res_question_id: '002',
      fieldName: 'service',
      fieldValue: serviceType,
    };

    this.updateSessionValues(data);
    if (serviceType === 'Switching Providers') {
      this.assignUsageHistoryValues();
    }
  }

  assignUsageHistoryValues() {
    const usageHistory = JSON.parse(
      sessionStorage.getItem('recommendedProducts')
    ).current_usage;
    const dataUsage = {
      res_question_id: '0030',
      fieldName: 'usage_history',
      fieldValue: usageHistory,
    };
    this.updateSessionValues(dataUsage);
    const questionID31 = {
      res_question_id: '0032',
      fieldName: 'avg_price_kwh',
      fieldValue: '0.0',
    };
    this.updateSessionValues(questionID31);
  }
  Mainarray = [];
  updateSessionValues(response) {
   
    if(this.userResponseUpdated != null)
    {
      const foundElem = _.findWhere(this.userResponseUpdated.userResponses, {
        res_question_id: response.res_question_id,
      });
      if (foundElem === undefined) {
        if (
          this.userResponseUpdated &&
          this.userResponseUpdated.userResponses === null
        ) {
          this.userResponseUpdated = {
            userResponses: [],
          };
        }
        this.userResponseUpdated.userResponses.push(response);
      } else {
        this.userResponseUpdated.userResponses = _.map(
          this.userResponseUpdated.userResponses,
          function (item, index) {
            if (
              item &&
              response &&
              item.res_question_id === response.res_question_id
            ) {
              item = response;
            }
            return item;
          }
        );
        this.userResponseUpdated = JSON.parse(
          JSON.stringify(this.userResponseUpdated)
        );
      }
    }else
    {
      var de  = this.Mainarray.filter(x => x.res_question_id == response.res_question_id)
      if(de.length == 0)
      {
        this.Mainarray.push(response);
      }else
      {
       
        this.Mainarray.splice(this.Mainarray.findIndex(v => v.res_question_id === response.res_question_id), 1);
        this.Mainarray.push(response);
      }
      sessionStorage.setItem('sevrviceDetails', JSON.stringify(this.Mainarray));
    }
    
  }


 remove(array, key, value) {
    const index = array.findIndex(obj => obj[key] === value);
    return index >= 0 ? [
        ...array.slice(0, index),
        ...array.slice(index + 1)
    ] : array;
}
  getSwitchDate(event) {
   
    if(event.currentTarget.checked == false)
    {
      
      if (event.currentTarget.value === 'Priority Move-In') {
        this.hgNewService = {
          newServiceValue1: true,
          newServiceValue2: false,
        };
        this.showDate = false;
        
        $("#StandardMoveIn").prop('checked',false)
        $("#PriorityMoveIn").prop('checked',true)

      } else if (event.currentTarget.value === 'Standard Move-In') {
        this.hgNewService = {
          newServiceValue1: false,
          newServiceValue2: true,
        };
        this.showDate = true;

        $("#PriorityMoveIn").prop('checked',false)
        $("#StandardMoveIn").prop('checked',true)
      }else if (event.currentTarget.value === 'Standard Switch') {
        this.hgSwitch = {
          switchValue1: true,
          switchValue2: false,
        };
        this.showDate = false;
        $("#SelfSelectedSwitch").prop('checked',false)
        $("#StandardSwitch").prop('checked',true)
        
      } else if (event.currentTarget.value === 'Self-Selected Switch') {
        this.hgSwitch = {
          switchValue1: false,
          switchValue2: true,
        };
        this.showDate = true;
        $("#StandardSwitch").prop('checked',false)
        $("#SelfSelectedSwitch").prop('checked',true)
      }

      return;
    }
    this.selectedSwitchValue = '';
    this.selectdSwitchDate = '';
    this.model = '';
    this.switchModel = '';
    if (this.swtprd) {
      this.isSwitchChecked = event.currentTarget.checked;
      if (this.isSwitchChecked === true) {
        this.btnEnable = true;
        this.ngClass = true;
        this.selectedSwitchValue = event.currentTarget.value;
        if (event.currentTarget.value === 'Standard Switch') {
          this.hgSwitch = {
            switchValue1: true,
            switchValue2: false,
          };
          this.showDate = false;
          sessionStorage.setItem('selectedSwitchValue', 'Standard Switch');
          sessionStorage.setItem('selectdSwitchDate', '');
          $("#SelfSelectedSwitch").prop('checked',false)
          $("#StandardSwitch").prop('checked',true)
        } else if (event.currentTarget.value === 'Self-Selected Switch') {
          this.hgSwitch = {
            switchValue1: false,
            switchValue2: true,
          };
          this.showDate = true;
          var result = new Date();
          result.setDate(new Date().getDate() + 8);
          this.date = result;
          this.model = this.dateObjectCstFormatted(this.date);
          $("#StandardSwitch").prop('checked',false)
          $("#SelfSelectedSwitch").prop('checked',true)
        }
      } else {
       
        if (event.currentTarget.value === 'Standard Switch') {
          this.hgSwitch = {
            switchValue1: true,
            switchValue2: false,
          };
          this.showDate = false;
          $("#SelfSelectedSwitch").prop('checked',false)
          $("#StandardSwitch").prop('checked',true)
          
        } else if (event.currentTarget.value === 'Self-Selected Switch') {
          this.hgSwitch = {
            switchValue1: false,
            switchValue2: true,
          };
          this.showDate = true;
          $("#StandardSwitch").prop('checked',false)
          $("#SelfSelectedSwitch").prop('checked',true)
        }
      }
    } else {
      this.isSwitchChecked = event.currentTarget.checked;
      this.selectedSwitchValue = event.currentTarget.value;
      if (this.isSwitchChecked === true) {
        this.btnEnable = true;
        this.ngClass = true;
        if (event.currentTarget.value === 'Priority Move-In') {
          this.hgNewService = {
            newServiceValue1: true,
            newServiceValue2: false,
          };
          this.showDate = false;
          sessionStorage.setItem('selectdSwitchDate', '');
          $("#StandardMoveIn").prop('checked',false)
          $("#PriorityMoveIn").prop('checked',true)
        } else if (event.currentTarget.value === 'Standard Move-In') {
          this.hgNewService = {
            newServiceValue1: false,
            newServiceValue2: true,
          };
          this.showDate = true;
          $("#PriorityMoveIn").prop('checked',false)
          $("#StandardMoveIn").prop('checked',true)
        }
      } else {
       
        if (event.currentTarget.value === 'Priority Move-In') {
          this.hgNewService = {
            newServiceValue1: true,
            newServiceValue2: false,
          };
          this.showDate = false;
          
          $("#StandardMoveIn").prop('checked',false)
          $("#PriorityMoveIn").prop('checked',true)

        } else if (event.currentTarget.value === 'Standard Move-In') {
          this.hgNewService = {
            newServiceValue1: false,
            newServiceValue2: true,
          };
          this.showDate = true;

          $("#PriorityMoveIn").prop('checked',false)
          $("#StandardMoveIn").prop('checked',true)
        }


      }
    }
  }

  dateObjectCstFormatted(model) {
    return moment(new Date(model)).format('YYYY-MM-DD HH:mm:ss').toString();
  }

  getDate() {
    this.selectdSwitchDate = '';
    this.btnEnable = true;
    this.ngClass = true;
    if (this.switchModel) {
      this.selectdSwitchDate = this.formatDateObject(
        this.dateObjectCstFormatted(this.switchModel)
      );
    } else {
      this.selectdSwitchDate = this.formatDateObject(
        this.dateObjectCstFormatted(this.model)
      );
    }
    sessionStorage.setItem('selectdSwitchDate', this.selectdSwitchDate);
  }

  private loadServiceTypes = {
    standardSwitch: this.setStandardSwitch.bind(this),
    selfSwitch: this.setSelfSelectedSwitch.bind(this),
    priorityMove: this.setPriorityMoveIn.bind(this),
    standardMove: this.setStandardMoveIn.bind(this),
  };

  next(enrollId) {
    sessionStorage.setItem('enrollId', enrollId);
    const accountId = this.recommendationService.hg_accountId;
    

    if(enrollId == "enrollment" && this.deviceWidth < 768)
    {
        
      if (this.serviceType === 'Switching Providers') {

        if(this.hgSwitch.switchValue1 || this.hgSwitch.switchValue2)
        {

          this.residentialService.validateHGAccountID(accountId)
          ? this.submitOrderProductDetails(enrollId)
          : this.loadSwitchTypes(enrollId);
          
              setTimeout(() => {
                $("#button12345")[0].scrollIntoView();
              }, 1000);
          
            
        }
        else
        {
          this.showDate = false;
          this.btnEnable = false;
          this.ngClass = false;
        }

       
      } 
      else if (this.serviceType === 'New Service') {
          
        if(this.hgNewService.newServiceValue1 || this.hgNewService.newServiceValue2)
        {
          
          this.residentialService.validateHGAccountID(accountId)
          ? this.submitOrderProductDetails(enrollId)
          : this.loadSwitchTypes(enrollId);

          var ids = this.IsOffSwitch ? "#button12346" : "#button12345";
            setTimeout(() => {
              $(ids)[0].scrollIntoView();
            }, 1000);
        
          
        }
        else
        {
          this.showDate = false;
          this.btnEnable = false;
          this.ngClass = false;
        }

      }else
      {
        this.showDate = false;
        this.btnEnable = false;
        this.ngClass = false;
      }
      
    }
    else
    {

      this.residentialService.validateHGAccountID(accountId)
      ? this.submitOrderProductDetails(enrollId)
      : this.loadSwitchTypes(enrollId);

    }
      
      
  
  }

  validateQuestionnairePerServiceType() {
    const removeQuestions = ['004', '005'];
    const userResponses = {
      userResponses: [],
    };
    if(this.userResponseUpdated != null)
    {
    if (this.serviceType === 'New Service') {
      let userResponse = JSON.parse(JSON.stringify(this.userResponseUpdated));
      userResponse = userResponse.userResponses;
      removeQuestions.map((row) => {
        const rowIdx = userResponse.findIndex(
          (ques) => ques.res_question_id === row
        );
        if (rowIdx >= 0) {
          userResponse.splice(rowIdx, 1);
        }
      });
      userResponse.map((row) => userResponses.userResponses.push(row));
      this.userResponseUpdated = JSON.parse(JSON.stringify(userResponses));
    }
  }
    this.updateFormattedAddress();

    if(this.userResponseUpdated != null)
    {
      sessionStorage.setItem(
        'userResponse',
        JSON.stringify(this.userResponseUpdated)
      );
      sessionStorage.setItem(
        'userResponseUpdated',
        JSON.stringify(this.userResponseUpdated)
      );
    }

  }

  updateFormattedAddress() {
    if (
      sessionStorage.getItem('formateAddress') &&
      typeof sessionStorage.getItem('formateAddress') !== 'string'
    ) {
      const Obj = {
        res_question_id: '008',
        fieldName: 'address',
        fieldValue: JSON.parse(sessionStorage.getItem('formateAddress')),
      };
      this.updateSessionValues(Obj);
    }
  }

  assignQuestionToSession() {
    const questionObj = JSON.parse(sessionStorage.getItem('userResponse'));
    sessionStorage.removeItem('userResponse');
    sessionStorage.setItem('userResponseUpdated', JSON.stringify(questionObj));
  }

  submitOrderProductDetails(enrollId) {
    const signUpProduct =
      this.recommendationService.signupProduct !== undefined
        ? this.recommendationService.signupProduct
        : JSON.parse(sessionStorage.getItem('signupProduct'));
    const energyProviderName = signUpProduct.energy_provider,
      utilityName = signUpProduct.utility_name,
      planName = signUpProduct.product_key,
      productID = signUpProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      .subscribe(
        (res: any) => {
          if (
            res.length > 0 &&
            productID !== res[0].ProductID &&
            this.residentialService.validateCreatedDateTime(res[0].createdDate)
          ) {
            this.assignNewEnergyProvidersRates();
          } else {
            this.loadSwitchTypes(enrollId);
            this.validateQuestionnairePerServiceType();
          }
        },
        (err) => {
          this.loadSwitchTypes(enrollId);
          this.validateQuestionnairePerServiceType();
        }
      );
  }

  assignNewEnergyProvidersRates() {
    const user = {
      esiid: null,
      questionStatusObj: sessionStorage.getItem('questionStatusObj'),
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  loadSwitchTypes(enrollId) {
    let switchTypes;
    if (this.serviceType === 'Switching Providers') {
      const questionID31 = {
        res_question_id: '0032',
        fieldName: 'avg_price_kwh',
        fieldValue: '0.0',
      };
      this.updateSessionValues(questionID31);
      switchTypes =
        this.selectedSwitchValue === 'Self-Selected Switch'
          ? 'selfSwitch'
          : 'standardSwitch';
    } else if (this.serviceType === 'New Service') {
      switchTypes =
        this.selectedSwitchValue === 'Standard Move-In'
          ? 'standardMove'
          : 'priorityMove';
    }
    this.loadServiceTypes[switchTypes]();

    
    var a  = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));
    if(a == null)
    {
      this.validateQuestionnairePerServiceType();
    }
   
    this.loadEnrollment(enrollId);
  }

  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }
  loadEnrollment(enrollId) {
    this.deviceWidth = window.innerWidth;
    if (!this.alertEnable) {
      if (this.deviceWidth > 768) {
        const elems = document.querySelectorAll('.active');
        if (elems !== null) {
          for (let i = 0; i < elems.length; ++i) {
            elems[i].classList.remove('active');
          }
        }
        const enrollTabValue = document.getElementById('enrollment_click');
        enrollTabValue.classList.add('active');
        enrollTabValue.classList.add('nav-link');
        const enrollElementObj = document.getElementById(enrollId);
        enrollElementObj.classList.remove('fade');
        enrollElementObj.classList.add('active');
        this.residentialService.setServiceFlag({ flag: true });
      } else {
        this.showEnrollmentComp = true;
        this.residentialService.setServiceFlag({
          flag: true,
          showEnrollmentComp: true,
        });
      }
    }
  }

  setStandardSwitch() {
    this.residentialService.updateSwitchServiceType(this.IsOffSwitch ? "Standard Move-In" : this.selectedSwitchValue);

    this.updateSessionValues(
      this.setObjectValues('004', this.selectedSwitchValue, 'typeSwitch_sp')
    );
    this.updateSessionValues(
      this.setObjectValues('002', 'Switching Providers', 'service')
    );
    this.alertEnable = false;
  }

  setSelfSelectedSwitch() {
    if (this.selectdSwitchDate !== '') {
      this.selectdSwitchDate = this.formatDateObject(this.selectdSwitchDate);
      this.residentialService.updateSwitchServiceType(this.IsOffSwitch ? "Standard Move-In" : this.selectdSwitchDate);
      this.updateSessionValues(
        this.setObjectValues('004', this.selectedSwitchValue, 'typeSwitch_sp')
      );
      this.updateSessionValues(
        this.setObjectValues('005', this.selectdSwitchDate, 'dateOfSwitch_sp')
      );
      this.updateSessionValues(
        this.setObjectValues('002', 'Switching Providers', 'service')
      );
      this.alertEnable = false;
    } else {
      this.disableNext();
    }
  }

  setStandardMoveIn() {
    if (this.selectdSwitchDate !== '') {
      this.selectdSwitchDate = this.formatDateObject(this.selectdSwitchDate);
      const someDate = new Date();
      const numberOfDaysToAdd = 2;
      someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
      if (new Date(this.selectdSwitchDate) < someDate && !this.IsOffSwitch) {
        this.selectedSwitchValue = 'Priority Move-In';
        this.hgNewService = {
          newServiceValue1: true,
          newServiceValue2: false,
        };
        this.showDate = false;
        this.selectdSwitchDate = '';
      }
      this.residentialService.updateSwitchServiceType(this.IsOffSwitch ? "Standard Move-In" : this.selectdSwitchDate);
      this.updateSessionValues(
        this.setObjectValues(
          '007',
          this.selectdSwitchDate,
          'dateOfSwitch_ns',
          this.selectedSwitchValue
        )
      );
      this.updateSessionValues(
        this.setObjectValues('002', 'New Service', 'service')
      );
      this.alertEnable = false;
    } else {
      this.disableNext();
    }
  }

  disableNext() {
    this.showDate = true;
    //this.btnEnable = false;
   // this.ngClass = false;
    alert('Select the Date');
    this.alertEnable = true;
  }

  setPriorityMoveIn() {
    this.residentialService.updateSwitchServiceType( this.IsOffSwitch ? "Standard Move-In" : this.selectedSwitchValue);
    this.updateSessionValues(
      this.setObjectValues(
        '007',
        '',
        'dateOfSwitch_ns',
        this.selectedSwitchValue
      )
    );
    this.updateSessionValues(
      this.setObjectValues('002', 'New Service', 'service')
    );
    this.alertEnable = false;
  }

  setObjectValues(
    questionId: string,
    itemValue: string,
    itemName: string,
    startType?: string
  ) {
    let objValue;
    if (startType === undefined) {
      objValue = {
        res_question_id: questionId,
        fieldName: itemName,
        fieldValue: itemValue,
      };
    } else {
      objValue = {
        res_question_id: questionId,
        fieldName: itemName,
        fieldValue: itemValue,
        startDateType: startType,
      };
    }
    return objValue;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  prevTab() {
    if (this.tableIndex > 0 || this.tableIndex === 0) {
      this.tableIndex = this.tableIndex - 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
    }
  }

  nextTab() {
    if (this.tableIndex < 4) {
      this.tableIndex = this.tableIndex + 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
    }
  }

  getActualUtilityName(utilName) {
    return this.loadActualUtilityName[utilName];
  }
  checkForWholeOrDecimal(number) {
    if (number == Math.floor(number)) {
      return `${number}.00`;
    } else {
      const newValue = number.toString();
      const newString =
        newValue.substring(newValue.indexOf('.') + 1).length >= 2
          ? newValue.substring(newValue.indexOf('.') + 1)
          : `${newValue.substring(newValue.indexOf('.') + 1)}0`;
      return `${newValue.substring(0, newValue.indexOf('.'))}.${newString}`;
    }
  }

  valueChanged(event) {
    this.model = event.selectedValue;
    this.selectdSwitchDate = this.model;
    sessionStorage.setItem('selectdSwitchDate', this.selectdSwitchDate);
    this.hgNewService.newServiceValue2 = true;
    this.hgNewService.newServiceValue1 = false;

  
    this.btnEnable = true;
    this.ngClass = true;

  }

  selectedSwitchChanged(event) {
    this.switchModel = event.selectedValue;
    this.selectdSwitchDate = this.switchModel;
    sessionStorage.setItem('selectdSwitchDate', this.selectdSwitchDate);
    this.btnEnable = true;
    this.ngClass = true;
  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  change(test)
  {

    if(test)
    {
      this.showDate = false;
    }else
    {
      this.showDate = true;
    }
  }


  REPStartDates()
  {

    var ProductID = "";
    var ESIID = "";
    var TDSP = "";
    var providerName = "";
    try{

      
      const signUpProduct =
      this.recommendationService.signupProduct !== undefined
        ? this.recommendationService.signupProduct
        : JSON.parse(sessionStorage.getItem('signupProduct'));
      providerName =  signUpProduct.energy_provider;
      ProductID = signUpProduct.ProductID;
      // if(!_.isEmpty(sessionStorage.getItem('tdspIndicator')))
      // {
      //   ESIID = sessionStorage.getItem('tdspIndicator');
        
      // }

      TDSP = signUpProduct.utility_name;
      if(providerName == "APGE Energy" || providerName == "Gexa Energy" || providerName == "Frontier Utilities")
      {
        ESIID =  this.residentialService.tdspindicator;
      }

      if(providerName == "4Change Energy")
      {
        ESIID =  this.residentialService.esiid;
      }

      
      var aa = this.serviceType.hgSwitch;
      var bb = this.serviceType.hgService;

      var ismoving = true;
      if(bb.sp)
      {
        ismoving = false;
      }

      
    }
    catch
    {
      var a = "";
    }

    if(providerName == "APGE Energy" || providerName == "Gexa Energy" || providerName == "Frontier Utilities" || providerName == "Chariot Energy")
    {
      this.CallDatesAPI(providerName,ESIID,false,ProductID,TDSP);
      this.CallDatesAPI(providerName,ESIID,true,ProductID,TDSP);

    }else
    {

      this.CallDatesAPI(providerName,ESIID,true,ProductID,TDSP);
    }


    
   

  }
  

  CallDatesAPI(providerName,ESIID,ismoving,ProductID,TDSP)
  {
        
    this.residentialService.getBlackOutDates(providerName,ESIID,ismoving,ProductID,TDSP).subscribe((res) => {
      let blackOutDates;
      res[0].BlackOutDates.map((date) => {
        const dateValue = new Date(date);
        blackOutDates = `${
          dateValue.getMonth() + 1
        }/${dateValue.getDate()}/${dateValue.getFullYear()}`;
        //this.blackOutDates.push(blackOutDates);
        this.residentialService.REP_Holiday_Dates.push(blackOutDates)
      });
      
      if(!_.isEmpty(res[0].ProviderData) && providerName == "APGE Energy")
      {
       
        var avlist = [];
        res[0].ProviderData.allValidDates.map((x) => {
          avlist.push(new Date(x.date))
        });

        var blacklist = this.getDatesInRange(new Date(), new Date(res[0].ProviderData.maximumDate),avlist)
        //this.minDate = new Date(res[0].ProviderData.minimumDate)
        //this.residentialService.REP_Max_Date = new Date(res[0].ProviderData.maximumDate)
        //this.blackOutDates = blacklist;
        if(ismoving)
        {
          this.residentialService.REP_Move_Max_Date  = new Date(res[0].ProviderData.maximumDate)
          this.residentialService.REP_movin_Dates = blacklist

        }else
        {
          this.residentialService.REP_SWI_Max_Date = new Date(res[0].ProviderData.maximumDate)
          this.residentialService.REP_switch_Dates = blacklist
        }
      }

      if(!_.isEmpty(res[0].ProviderData) && providerName == "4Change Energy")
      {
      
        var dates = [];
        const extractedActions: string[][] = this._4ChangeExtractDate(res[0].ProviderData);
        // console.log("Priority_Move_In:", extractedActions[0]);
        // console.log("Self_Selected_Switch:", extractedActions[1]);
        // if(this.serviceType.selectedSwitchValue == "Standard Move-In")
        // {
        //   dates = extractedActions[0];
        // }
        // else
        // {
        //   dates = extractedActions[1];
        // }

        
          dates = extractedActions[0];
          var avlist = [];
          dates.map((x) => {
            avlist.push(new Date(x))
          });
          var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
          this.residentialService.REP_movin_Dates = blacklist
          this.residentialService.REP_Move_Max_Date = new Date(dates[dates.length - 1])

        
          dates = extractedActions[1];
          var avlist = [];
          dates.map((x) => {
            avlist.push(new Date(x))
          });
          var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
          this.residentialService.REP_switch_Dates = blacklist
          this.residentialService.REP_SWI_Max_Date = new Date(dates[dates.length - 1])
        

       
        
      
        //this.minDate = new Date(res[0].ProviderData.minimumDate)
        //this. this.residentialService.REP_Max_Date = new Date(dates[dates.length - 1])
        //this.blackOutDates = blacklist;
       
     
        

      }


      if(!_.isEmpty(res[0].ProviderData) && (providerName == "Gexa Energy" || providerName == "Frontier Utilities"))
      {
        
        var dates = [];
        const extractedActions: string[][] = this.GexaExtractDate(res[0].ProviderData);
        // console.log("Priority_Move_In:", extractedActions[0]);
        // console.log("Self_Selected_Switch:", extractedActions[1]);
        dates = extractedActions[0];

        var avlist = [];
        dates.map((x) => {
          avlist.push(new Date(x))
        });
        
        var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
        //this.minDate = new Date(res[0].ProviderData.minimumDate)
        //this.maxDate = new Date(dates[dates.length - 1])
        //this.blackOutDates = blacklist;
        if(ismoving)
        {
          this.residentialService.REP_Move_Max_Date = new Date(dates[dates.length - 1])
          this.residentialService.REP_movin_Dates = blacklist

        }else
        {
          this.residentialService.REP_SWI_Max_Date = new Date(dates[dates.length - 1])
          this.residentialService.REP_switch_Dates = blacklist
        }
       
      }

      if(providerName == "BKV Energy")
      {
        
        this.residentialService.REP_Move_Max_Date = new Date(new Date().setDate(new Date().getDate() + 44));
        this.residentialService.REP_SWI_Max_Date = new Date(new Date().setDate(new Date().getDate() + 44));
        if(ismoving)
        {
          let currentDate = new Date(),
          endDate,
          noOfDaysToAdd = 2,
          count = 0;
          while (count < noOfDaysToAdd) {
          endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
          if (endDate.getDay() != 0 && endDate.getDay() != 6) {
            count++;
          }
        }
       var Dates = new Date(this.suffixZeroToSelectedSwitchDate(endDate));
  
       const year = Dates.getFullYear();
       const month = String(Dates.getMonth() + 1).padStart(2, '0'); // Add 1 to month since it's zero-based
       const day = String(Dates.getDate()).padStart(2, '0');
       
       // Create the formatted date string in 'YYYY-MM-DD' format
       //this.minDate 
       this.residentialService.REP_Move_Min_Date = `${year}-${month}-${day}`;
       this.residentialService.REP_SWI_Min_Date = `${year}-${month}-${day}`;
      
        }
  
       
      }
  
      if(providerName == "Chariot Energy")
      {
  
       
        
        this.residentialService.REP_Move_Max_Date = new Date(new Date().setDate(new Date().getDate() + 59));
        this.residentialService.REP_SWI_Max_Date = new Date(new Date().setDate(new Date().getDate() + 59));

          let currentDate = new Date(),
          endDate,
          noOfDaysToAdd = ismoving ? 1 : 2,
          count = 0;
          while (count < noOfDaysToAdd) {
          endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
          if (endDate.getDay() != 0) {
            count++;
          }
        }
        var Dates = new Date(this.suffixZeroToSelectedSwitchDate(endDate));
  
        const year = Dates.getFullYear();
        const month = String(Dates.getMonth() + 1).padStart(2, '0'); // Add 1 to month since it's zero-based
        const day = String(Dates.getDate()).padStart(2, '0');
        
        // Create the formatted date string in 'YYYY-MM-DD' format
        //this.minDate = `${year}-${month}-${day}`;
        if(ismoving)
        {
          this.residentialService.REP_Move_Min_Date = `${year}-${month}-${day}`;
        }
        else
        {
          this.residentialService.REP_SWI_Min_Date = `${year}-${month}-${day}`;

        }
        
  
       
      }
  

      if(!_.isEmpty(res[0].ProviderData) && providerName == "Rhythm Energy")
      {
      
        var dates = [];
        
        
          dates = res[0].ProviderData;
          var avlist = [];
          dates.map((x) => {
            avlist.push(new Date(x))
          });
          var blacklist = this.getDatesInRange(new Date(), new Date(dates[dates.length - 1]),avlist)
          this.residentialService.REP_movin_Dates = blacklist
          this.residentialService.REP_Move_Max_Date = new Date(dates[dates.length - 1])

          this.residentialService.REP_switch_Dates = blacklist
          this.residentialService.REP_SWI_Max_Date = new Date(dates[dates.length - 1])
          
        

       
        
      
        //this.minDate = new Date(res[0].ProviderData.minimumDate)
        //this. this.residentialService.REP_Max_Date = new Date(dates[dates.length - 1])
        //this.blackOutDates = blacklist;
       
     
        

      }

    });
  }

  getDatesInRange(
    startDate: Date,
    endDate: Date,
    excludedDates: Date[] = []
  ): Date[] {
    const datesInRange: Date[] = [];
    let currentDate = new Date(startDate);
  
    const compareDates = (date1: Date, date2: Date): boolean => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };
  


    while (currentDate <= endDate) {
      // const dateExistsInExcludedList = excludedDates.some(
      //   (excludedDate) => currentDate.getTime() === excludedDate.getTime()
      // );

      const dateExistsInExcludedList = excludedDates.some(
        (excludedDate) => compareDates(currentDate, excludedDate)
      );
  
      if (!dateExistsInExcludedList) {
        datesInRange.push(new Date(currentDate));
      }
  
      currentDate.setDate(currentDate.getDate() + 1);
    }
  
    return datesInRange;
  }


  _4ChangeExtractDate(data): string[][] {
    const actions: string[][] = [[], [], []]; // Array to hold the three arrays

    // Iterate through the data
    
    data.GetTduEnrollmentDatesResult.Dates.EnrollmentDate.forEach(dateItem => {
            // Iterate through actions for each date and add to respective array
            dateItem.Actions.string.forEach((action, index) => {
                if (action === "Priority_Move_In") {
                    actions[0].push(dateItem.Date);
                } else if (action === "Self_Selected_Switch") {
                    actions[1].push(dateItem.Date);
                } else if (action === "Standard_Move_In") {
                    actions[0].push(dateItem.Date);
                }
            });
        });
    

    return actions;
}

GexaExtractDate(data): string[][] {
  const actions: string[][] = [[], [], []]; // Array to hold the three arrays

  // Iterate through the data
  
data.GetAvailableStartDatesResult.AvailableStartDateDetails.AvailableStartDateDetails.forEach(dateItem => {
          // Iterate through actions for each date and add to respective array
    actions[0].push(dateItem.MoveDate);
 });
  

  return actions;
}

  

suffixZeroToSelectedSwitchDate(d) {
  let newDate;
  if (new Date(d) < new Date()) d = new Date();
  newDate = this.setDateValueFor4CE(
    `${d.getMonth() + 1}`,
    `${d.getDate()}`,
    `${d.getFullYear()}`
  );
  return newDate;
}

setDateValueFor4CE(month, day, year) {
  return `${this.pad(month)}/${this.pad(day)}/${year}`;
}
pad(number) {
  return (number < 10 ? '0' : '') + number;
}

}
